//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '~/components/Shared/Button'
export default {
  components: {
    Button,
  },
  methods: {
    saveAndClose() {
      this.$emit('saveAndClose')
    },

    close() {
      this.$emit('close')
    },
  },
}
